import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { Image } from 'app/components';
import { NavLink, generatePath } from 'react-router-dom';
import { useConfig } from 'app/hooks';
import { FullwidthCarousel } from './styles';
// import placeholderImg from './../../../../assets/images/placeholder.jpg';

const propTypes = {
  item: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired
};

const Box = ({ item }) => {
  // eslint-disable-next-line no-unused-vars
  const [_, i18n] = useTranslation();
  const { language } = i18n;
  const { routes } = useConfig();
  const to = {
    pathname: generatePath(routes.competitionDetail.pattern, { id: item.id })
  };

  const languageContents = useMemo(
    () => ({
      headline1: language === 'en' ? 'headline1EN' : 'headline1',
      shortDescription: language === 'en' ? 'shortDescriptionEN' : 'shortDescription'
    }),
    [language]
  );

  return (
    <>
      <FullwidthCarousel>
        <NavLink to={to}>
          <div className="giftCardSlider">
            <Image src={item?.picture} className="cinema-rent__carousel-image" />
          </div>
          <div className="description_part">
            <h2>{item?.[languageContents.headline1]}</h2>
            {parse(item?.[languageContents.shortDescription])}
          </div>
        </NavLink>
      </FullwidthCarousel>
    </>
  );
};

Box.propTypes = propTypes;

export default Box;
